import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomDialog, CustomTextField } from "../../../../../../../common/components";
import { translate } from "../../../../../../../common/providers";
import styles from "./ManualCreationDialog.module.css";
import { useApi } from "../../../../../../../common/hooks";
import { NotesService } from "../../../../../../../api";
import { debounce } from "../../../../../../../common/utils";

const debounceFunc = debounce((func) => func(), 500);

const ManualCreationDialog = ({
	defaultValue = "",
	label = "",
	onClose,
	open,
	onSubmit,
	submitLabel = "",
	title = "",
}) => {
	const { call: checkIfTitleExists } = useApi(NotesService.checkIfTitleExists);
	const projectId = useSelector(({ context }) => context.project?.id);
	const [value, setValue] = useState("");
	const [nameExist, setNameExist] = useState(false);
	const [identicalName, setIdenticalName] = useState(false);
	useEffect(() => {
		if (defaultValue && open) {
			setValue(defaultValue);
		}
	}, [defaultValue, open]);
	const handleChange = (e) => {
		const newValue = e.target.value;
		setValue(newValue);
		if (newValue !== defaultValue) {
			setIdenticalName(false);
			debounceFunc(() => {
				checkIfTitleExists({ projectId }, { title: newValue })
					.then((data) => {
						setNameExist(data.value);
					})
					.catch(console.error);
			});
		} else {
			setIdenticalName(true);
		}
	};
	const handleSubmit = () => {
		onSubmit(value);
	};
	const handleClose = () => {
		onClose();
		setValue("");
		setNameExist(false);
		setIdenticalName(false);
	};
	return (
		<CustomDialog
			open={open}
			submitDisabled={nameExist || value?.length === 0 || identicalName}
			submitLabel={submitLabel}
			title={title}
			onClose={handleClose}
			onSubmit={handleSubmit}
		>
			<div>
				<CustomTextField
					autoFocus
					fullWidth
					required
					className={styles.textField}
					error={nameExist}
					label={label}
					size="small"
					submitDisabled={!value || nameExist}
					value={value}
					variant="outlined"
					onChange={handleChange}
				/>
				{nameExist && <div className={styles.error}>{translate("notes.action.create.error.exist")}</div>}
				{identicalName && (
					<div className={styles.error}>{translate("notes.action.create.error.identical")}</div>
				)}
				{value?.length === 0 && (
					<div className={styles.error}>{translate("notes.action.create.error.empty")}</div>
				)}
			</div>
		</CustomDialog>
	);
};

export default ManualCreationDialog;
